"use client";

import { useRouter } from "next/navigation";
import { useTransition } from "react";
import { LOCALES } from "@/lib/i18n/config";
import { setLocale } from "@/lib/i18n/actions";
import { useI18n } from "@/lib/i18n/I18nProvider";
import "./language-switcher.css";

/**
 * EN / PL segmented switch. The choice is stored in the NEXT_LOCALE cookie by
 * a server action, then the current route is re-rendered in place (no full
 * reload, scroll position kept).
 */
export function LanguageSwitcher({ className = "" }: { className?: string }) {
  const { locale, t } = useI18n();
  const router = useRouter();
  const [pending, startTransition] = useTransition();
  return (
    <div
      className={`ec-lang ${className}`}
      role="group"
      aria-label={t.language.label}
      aria-busy={pending || undefined}
    >
      {LOCALES.map((code) => (
        <button
          key={code}
          type="button"
          lang={code}
          title={t.language.names[code]}
          aria-pressed={code === locale}
          onClick={() => {
            if (code === locale || pending) return;
            startTransition(async () => {
              await setLocale(code);
              router.refresh();
            });
          }}
        >
          {code.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
